import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface IFeedback {
  [key: string]: any;
  loading: boolean;
  data: any;
  tottal?: number;
}

interface IFeedbackInfo {
  id: number;
  TypeEnum: number; // 类型(1:产品咨询;2:产品建议;3:产品BUG)
  FeedbackTheme: string; // 主题
  StatusEnum: number; // 状态(1:待处理;2:处理中;3:已关闭)
  HandleName: string; // 当前处理人
  CreatedName: string; // 登记人
  OperateName: string; // 默认经办人
  SolveResult: number; // 解决结果(1:未解决;2:已解决;3:不处理;0:空)
  CreatedTime: string; // 创建日期
  ModifiedTime: string; // 更新日期
  CloseTime: string; // 关闭日期
  ModuleName: string; // 模块名称
  EditionName: string; // 产品版本
  SubSystemName: string; // 子系统
  PmName: string; // 二开PM
  ProjectName: string; // 项目名称
  CustomerTopName: string; // 客户名称
  FeedbackDescribe: string; // 描述
  FileUpload: Array<{}>; // 附件
  EstimatedTime: string; // 预计完成时间
  Workload: number; // 产品工作量
  PriorityLevel: string; // 优先级
  Analysis: string; // 项目分析
  ProcessInfo: Array<{}>; // 处理过程
}

export interface IState {
  [key: string]: any;
  feedbackList: IFeedback; // 首页反馈列表
  feedbackDetail: IFeedback; // 反馈详细信息
}

export const state: IState = {
  feedbackList: {
    loading: false,
    data: [],
    total: 0
  },
  feedbackDetail: {
    loading: false,
    data: []
  },
  feedbackDetailV2: {
    loading: false,
    data: []
  },
  // 客户列表
  customerList: {
    loading: false,
    data: []
  },
  employeeList: {
    loading: false,
    data: []
  },
  pmEmployeeList: {
    loading: false,
    data: []
  },
  ProductValueList: {
    loading: false,
    data: []
  },
  projectList: {
    loading: false,
    data: []
  },
  productSubsystemList: {
    loading: false,
    data: []
  },
  productModuleList: {
    loading: false,
    data: []
  },
  productEditionList: {
    loading: false,
    data: []
  },
  // 包括被禁用的数据
  allproductSubsystemList: {
    loading: false,
    data: []
  },
  allproductModuleList: {
    loading: false,
    data: []
  },
  allproductEditionList: {
    loading: false,
    data: []
  },

  feedbackResult: {
    loading: false,
    success: false,
    request: {},
    message: ''
  },
  transferResult: {
    loading: false,
    success: false,
    request: {},
    message: ''
  },
  externalAddResult: {
    loading: false,
    success: false,
    data: {},
    message: ''
  },
  feedbackTotal: {
    loading: false,
    data: {}
  },
  subsystem: {
    loading: false,
    data: []
  },
  assignee: {
    loading: false,
    success: false,
    data: []
  },
  defaultAssignee: {
    loading: false,
    success: false,
    data: []
  },
  addAssignee: {
    loading: false
  },
  assigneePermission: {
    loading: false,
    success: false
  },
  revokeFeedback: {
    loading: false,
    success: false
  },
  feedbackSatisfactionList: {
    loading: false,
    success: false,
    data:[]
  },
  feedbackSatisfactionResult: {
    loading: false,
    success: false,
    request: {},
    message: ''
  },
  exsitFeedbacktransfer:{
    loading: false,
    exsit:false
  },
  savefeedbacktransferResult:{
    loading:false,
    success:false,
    data:[],
    message:''
  },
  feedbacktransferList:{
    loading: false,
    success: false,
    data:[]
  },
  feedbacktransferResult:{
    loading:false,
    success:false,
    message:''
  },
  isProductUser:{
    loading:false,
    success:false,
    data:''
  },
  isSubmitBugByUser:{
    loading:false,
    success:false,
    data:''
  },
  defaultAssigneeByModule:{
    loading:false,
    success:false,
    data:''
  }
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  feedbackList: (myState: IState) => myState.feedbackList,
  feedbackDetail: (myState: IState) => myState.feedbackDetail,
  feedbackDetailV2: (myState: IState) => myState.feedbackDetailV2,
  customerList: (myState: IState) => myState.customerList,
  employeeList: (myState: IState) => myState.employeeList,
  pmEmployeeList: (myState: IState) => myState.pmEmployeeList,
  ProductValueList:(myState:IState) =>myState.ProductValueList,
  projectList: (myState: IState) => myState.projectList,
  productSubsystemList: (myState: IState) => myState.productSubsystemList,
  productModuleList: (myState: IState) => myState.productModuleList,
  productEditionList: (myState: IState) => myState.productEditionList,
  // 包括被禁用的数据
  allproductSubsystemList: (myState: IState) => myState.allproductSubsystemList,
  allproductModuleList: (myState: IState) => myState.allproductModuleList,
  allproductEditionList: (myState: IState) => myState.allproductEditionList,

  feedbackResult: (myState: IState) => myState.feedbackResult,
  transferResult: (myState: IState) => myState.transferResult,
  feedbackTotal: (myState: IState) => myState.feedbackTotal,
  subsystem: (myState: IState) => myState.subsystem,
  assignee: (myState: IState) => myState.assignee,
  defaultAssignee: (myState: IState) => myState.defaultAssignee,
  addAssignee: (myState: IState) => myState.addAssignee,
  assigneePermission: (myState: IState) => myState.assigneePermission,
  revokeFeedback: (myState: IState) => myState.revokeFeedback,
  feedbackSatisfactionList:(mystate:IState)=>mystate.feedbackSatisfactionList,
  feedbackSatisfactionResult:(mystate:IState)=>mystate.feedbackSatisfactionResult,
  exsitFeedbacktransfer:(mystate:IState)=>mystate.exsitFeedbacktransfer,
  savefeedbacktransferResult:(mystate:IState)=>mystate.savefeedbacktransferResult,
  feedbacktransferList:(mystate:IState)=>mystate.feedbacktransferList,
  feedbacktransferResult:(mystate:IState)=>mystate.feedbacktransferResult,
  // 转单
  externalAddResult:(mystate:IState)=>mystate.externalAddResult,
  isProductUser:(mystate:IState)=>mystate.isProductUser,
  isSubmitBugByUser:(mystate:IState)=>mystate.isSubmitBugByUser,
  defaultAssigneeByModule:(mystate:IState)=>mystate.defaultAssigneeByModule
};
